import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';
export interface BudgetImportBody {
  acctGlBudgetImportId: number;
  fileName: string;
  originalFileName: string;
  companyId: number;
  startDate: string | null;
  endDate: string | null;
  importType: number;
  loggedInClientId: string;
  multiCompanyImport: boolean;
}
const useImportBudgetApi = () => {
  const call = useCallback(
    (params?: BudgetImportBody) => axiosInstance.post(api.budgetImport, params),
    []
  );
  const { execute, isLoading } = useAsync(call, false);

  return { importExecute: execute, importLoading: isLoading };
};
export default useImportBudgetApi;
